<template>
    <div>
        <v-row class="d-flex justify-center align-center">
            <v-col class="text-h6 text-center">
                {{ $t('labels.pleaseEnterEmail') }}
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="d-flex justify-center align-center">
                <InputField
                    v-model="email"
                    :errorBorder="!emailValidation"
                    :label="'* ' + $t('fields.email')"
                ></InputField>
            </v-col>
            <v-col cols="12" class="d-flex justify-center align-center">
                <CheckBox class="ma-0 pt-0" v-model="acceptedTOS" :label="$t('labels.acceptTos')"></CheckBox>
                &nbsp;<a :href="termsLink">T&C</a>
            </v-col>
            <v-col cols="12" class="d-flex justify-center align-center">
                <div id="captcha"></div>
            </v-col>
        </v-row>
        <v-row class="d-flex justify-space-between">
            <v-btn
                class="white--text ma-2 ml-3 mt-6"
                color="#f6bb14"
                variant="text"
                :disabled="!acceptedTOS || !isCaptchaValid"
                :loading="saving"
                @click="saveClick"
            >
                {{ $t('buttons.save') }}
            </v-btn>
            <v-btn class="white--text ma-2 mr-3 mt-6" color="#0da6b1" variant="text" @click="cancelClick">
                {{ $t('buttons.cancel') }}
            </v-btn>
        </v-row>
    </div>
</template>

<script>
import InputField from '../../trinkets/InputField';
import CheckBox from '../../trinkets/CheckBox';

export default {
    name: 'EmailVerification',
    components: {InputField, CheckBox},
    emits: ['close', 'success'],
    props: {
        openApplication: {
            type: Boolean,
            default: false,
        },
        vacancyApplication: {
            type: Boolean,
            default: false,
        },
        vacancyId: [String, Number],
    },
    data: function () {
        return {
            email: '',
            emailValidation: true,
            saving: false,
            recaptchaScript: null,
            acceptedTOS: false,
            isCaptchaValid: false,
            captchaToken: '',
            mySiteKey: this.$getSettings('RECAPTCHA_SITE_KEY'),
            termsLink: this.$getSettings('TERMS_AND_COND_LINK'),
        };
    },
    watch: {
        openApplication(newVal) {
            if (newVal || this.vacancyApplication) {
                this.resetCaptcha();
            }
        },
        vacancyApplication(newVal) {
            if (newVal || this.openApplication) {
                this.resetCaptcha();
            }
        },
    },
    methods: {
        cancelClick() {
            this.setDefaults();
            this.$emit('close');
        },
        loadCaptcha() {
            this.recaptchaScript = document.createElement('script');
            this.recaptchaScript.setAttribute(
                'src',
                'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit',
            );
            document.head.appendChild(this.recaptchaScript);
        },
        onloadCallback() {
            grecaptcha.render(document.getElementById('captcha'), {
                callback: this.captchaValidation,
                'expired-callback': this.captchaExpired,
                sitekey: this.mySiteKey,
                class: 'g-recaptcha',
            });
        },
        resetCaptcha() {
            grecaptcha.reset();
            this.captchaExpired();
        },
        setDefaults() {
            this.recaptchaScript = null;
            this.isCaptchaValid = false;
            this.captchaToken = '';
            this.acceptedTOS = false;
            this.saving = false;
            this.email = '';
        },
        captchaValidation(val) {
            if (val != '') {
                this.isCaptchaValid = true;
                this.captchaToken = val;
            }
        },
        captchaExpired() {
            this.isCaptchaValid = false;
            this.captchaToken = '';
        },
        saveClick() {
            let success = true;

            if (this.email == '') {
                success = false;
                this.emailValidation = false;
            } else {
                if (!this.$checkEmail(this.email)) {
                    success = false;
                    this.emailValidation = false;
                } else {
                    this.emailValidation = true;
                }
            }
            if (success) {
                this.saving = true;
                this.$APICall(
                    'post',
                    'web-application-link',
                    {
                        email: this.email,
                        vacancyId: this.vacancyId,
                        openApplication: this.openApplication,
                        vacancyApplication: this.vacancyApplication,
                        captchaToken: this.captchaToken,
                    },
                    (data, success) => {
                        if (success) {
                            this.$emit('success');
                        } else {
                            this.$alert(this.$t('alerts.basicError'));
                        }
                        this.saving = false;
                        this.$emit('close');
                        this.setDefaults();
                        // Token is single-use, a fresh one is needed for the next submit
                        this.resetCaptcha();
                    },
                    false,
                );
            }
        },
    },

    mounted() {
        window.onloadCallback = this.onloadCallback;
        this.loadCaptcha();
    },
};
</script>

<style scoped></style>
